<div class="cd-card-header">
  <div class="cd-header-text">
    <div class="cd-header-content">
      <mat-icon>event_repeat</mat-icon>
      <h2>Weekly Hours</h2>
    </div>
    <span class="cd-subtitle">Set your typical availability</span>
  </div>
</div>

<div class="cd-intervals-container">
  @if (editing()) {
    <!-- ── EDIT MODE ──────────────────────────────────────────── -->
    @for (day of days(); track day.dayOfWeek) {
      <div class="cd-day-row" [class.cd-day-enabled]="day.enabled">
        <!-- Left: the badge itself toggles the day on and off -->
        <div class="cd-day-toggle">
          <button
            type="button"
            class="cd-day-badge"
            [class.cd-day-badge-on]="day.enabled"
            [attr.aria-pressed]="day.enabled"
            [attr.aria-label]="day.day"
            [matTooltip]="day.enabled ? 'Mark unavailable' : 'Mark available'"
            (click)="toggleDay(day.dayOfWeek, !day.enabled)"
            [attr.data-testid]="day.day.toLowerCase() + '-availability-toggle'"
          >
            {{ letter(day.day) }}
          </button>
        </div>

        <!-- Right: intervals or "Unavailable" -->
        <div class="cd-day-intervals">
          @if (day.enabled) {
            @for (interval of day.intervals; track $index) {
              <div class="cd-interval-row">
                <mat-form-field class="cd-time-slot" subscriptSizing="dynamic">
                  <input
                    matInput
                    [matTimepicker]="startPicker"
                    [matTimepickerMin]="earliestTime"
                    [ngModel]="interval.start"
                    (ngModelChange)="setTime(day.dayOfWeek, $index, 'start', $event)"
                    placeholder="9:00 AM"
                    [attr.data-testid]="day.day.toLowerCase() + '-start-time-input-' + $index"
                  />
                  <mat-timepicker-toggle matIconSuffix [for]="startPicker" />
                  <mat-timepicker #startPicker />
                </mat-form-field>

                <span class="cd-range-separator" aria-hidden="true">to</span>

                <mat-form-field class="cd-time-slot" subscriptSizing="dynamic">
                  <input
                    matInput
                    [matTimepicker]="endPicker"
                    [matTimepickerMin]="earliestTime"
                    [ngModel]="interval.end"
                    (ngModelChange)="setTime(day.dayOfWeek, $index, 'end', $event)"
                    placeholder="3:00 PM"
                    [attr.data-testid]="day.day.toLowerCase() + '-end-time-input-' + $index"
                  />
                  <mat-timepicker-toggle matIconSuffix [for]="endPicker" />
                  <mat-timepicker #endPicker />
                </mat-form-field>

                <button
                  matIconButton
                  class="cd-remove-btn"
                  matTooltip="Remove"
                  (click)="removeInterval(day.dayOfWeek, $index)"
                  [attr.data-testid]="day.day.toLowerCase() + '-remove-interval-' + $index"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }

            <!-- Add sits on its own line so every interval row lines up -->
            <button
              matButton
              class="cd-add-btn"
              [disabled]="day.intervals.length >= maxIntervalsPerDay"
              (click)="addInterval(day.dayOfWeek)"
              [attr.data-testid]="day.day.toLowerCase() + '-add-interval-button'"
            >
              <mat-icon>add</mat-icon>
              Add hours
            </button>
          } @else {
            <span class="cd-unavailable">Unavailable</span>
          }

          @if (dayError(day); as error) {
            <span
              class="cd-day-error"
              role="alert"
              [attr.data-testid]="day.day.toLowerCase() + '-availability-error'"
            >
              {{ error }}
            </span>
          }
        </div>
      </div>
    }
  } @else {
    <!-- ── READ-ONLY SUMMARY ──────────────────────────────────── -->
    @for (day of days(); track day.dayOfWeek) {
      <div class="cd-summary-row">
        <span
          class="cd-day-badge"
          [class.cd-day-badge-on]="day.enabled"
          [attr.aria-label]="day.day"
        >
          {{ letter(day.day) }}
        </span>
        @if (day.enabled && day.intervals.length) {
          <span class="cd-summary-times">
            @for (interval of day.intervals; track $index; let last = $last) {
              {{ interval.start | date: 'h:mm a' }} – {{ interval.end | date: 'h:mm a' }}
              @if (!last) {
                ,&nbsp;
              }
            }
          </span>
        } @else {
          <span class="cd-unavailable">Unavailable</span>
        }
      </div>
    }
  }
</div>
